import { Tabs, Button, Group, Container, Text, Divider } from "@mantine/core";
import React, { useState } from "react";
import ReactJson from "react-json-view";
import _ from "lodash";
import { useTranslation } from "react-i18next";

const FormWizard = ({
  wizard,
  getChildContainers,
  getChildFields,
  renderContainer,
  renderField,
  confirmSubmit,
  showDivider = true,
  form,
  ...props
}) => {
  const [currentTab, setCurrentTab] = useState(wizard.defaultValue);
  const [confirming, setConfirming] = useState(false);
  const { t } = useTranslation();
  const handleConfirm = async () => {
    if (!_.isFunction(confirmSubmit)) return console.log("Confirm Submit");
    if (confirming) return;
    if (form.isUniqueCheckPending?.()) return;

    const validation = form.validate?.();
    if (validation?.hasErrors) return;

    setConfirming(true);
    await confirmSubmit();
    setConfirming(false);
  };

  const toPage = (index) => {
    if (index < 0 || index > wizard.steps.length - 1) return;
    if (index === wizard.steps.length - 1) {
      form.validate?.();
    }
    setCurrentTab(wizard.steps[index].label);
  };

  const uniqueCheckPending = form.isUniqueCheckPending?.() ?? false;

  const renderNextButton = (index) => {
    return index === wizard.steps.length - 1 ? (
      <Button
        onClick={handleConfirm}
        disabled={!_.isEmpty(form.errors) || uniqueCheckPending}
        loading={confirming || uniqueCheckPending}
      >
        {uniqueCheckPending ? t("Checking...") : t("Confirm")}
      </Button>
    ) : (
      <Button onClick={() => toPage(index + 1)}>{t("Next")} </Button>
    );
  };
  const { t: translate } = useTranslation();

  const renderPrevButton = (index) => {
    return index === 0 ? null : (
      <Button variant="default" onClick={() => toPage(index - 1)}>
        {t("Prev")}
      </Button>
    );
  };

  return (
    <>
      {/* {<ReactJson src={wizard} style={{ background: "white" }} collapsed />} */}
      {showDivider && <Divider />}
      <Tabs value={currentTab} {...wizard.props} key={wizard.key}>
        <Tabs.List pt={"md"}>
          {wizard.steps?.map(({ label, key, iconSize = 14, ...t }, index) => (
            <Tabs.Tab
              key={key}
              // icon={<t.icon size={iconSize} />}
              onClick={() => toPage(index)}
              value={label}
            >
              <Text size={"xs"}>{translate(label)}</Text>
            </Tabs.Tab>
          ))}
        </Tabs.List>
        {wizard.steps?.map(({ label, key }, index) => (
          <Tabs.Panel key={key} value={label} ml="xl" pt="xl" pb="xl">
            <Container
              sx={{
                display: "flex",
                flexDirection: "column",
                minHeight: wizard.props?.style?.minHeight ?? 400,
              }}
            >
              <div style={{ flex: 1, paddingBottom: 16 }}>
                {getChildContainers(key).map((c) => renderContainer(c))}
                {getChildFields(key).map((f) => renderField(f))}
              </div>
              <Group position="right" mt="md">
                <span>{renderPrevButton(index)}</span>
                <span>{renderNextButton(index)}</span>
              </Group>
            </Container>
          </Tabs.Panel>
        ))}
      </Tabs>
    </>
  );
};

export default FormWizard;
